import classNames from "classnames";
import { IKeyValueLog } from "motw_core/Entity/IKeyValueLog";
import { ILogEntry } from "motw_core/Entity/ILogEntry";
import * as React from "react";
import { LogEntryRow } from "source/app/presentation/MainPanel/Log/LogEntries/Row/LogEntryRow";
import { EEventType } from "source/app/services/Events/EEventType";
import { SubscribeToEvent } from "source/app/services/Events/Events";
import { FadeInArray } from "../../../Shared/Animation/FadeInArray";
import { ShowReloadIcon } from "../ShowReloadIcon/ShowReloadIcon";
import * as styles from "./LogEntries.css";
import { ILogEntries } from "./LogEntryProps";
import IsNotEqual, { AreEqual } from "source/app/services/Shared/ReactHelpers";
const moment = require("moment");

const LogEntriesComponent = ({
    data,
    HandleDataChanged,
    whenClicked,
    // showReloadIcon,
}: ILogEntries) => {
    const [keyValueLogs, setKeyValueLogs] = React.useState<IKeyValueLog[]>([]);

    React.useEffect(() => {
        SubscribeToEvent<IKeyValueLog[]>(
            EEventType.KeyValueLogs_DataChanged,
            (keyValueLogs) => {
                setKeyValueLogs(keyValueLogs);
            }
        );
    }, []);

    return data.length > 0 ? (
        <div>
            {/* <ShowReloadIcon when={showReloadIcon} /> */}
            <div
                className={classNames("table", styles.entries)}
                onClick={whenClicked}
            >
                <FadeInArray
                    label="logEntries"
                    array={data}
                    render={(row) => (
                        <LogEntryRow
                            data={data}
                            row={row}
                            HandleDataChanged={HandleDataChanged}
                            whenClicked={whenClicked}
                            keyValueLogs={keyValueLogs}
                        />
                    )}
                    itemDelayMs={50}
                />
            </div>
        </div>
    ) : null; // Prevent rendering if data is empty
};

const isLogEntriesMemoized = true;

export const LogEntries = isLogEntriesMemoized
    ? React.memo(LogEntriesComponent, (prevProps, nextProps) => {
          var result = AreEqual(prevProps.data, nextProps.data);
          var shouldReRender = result == false;
          console.log(`[LogEntries] should re-render: ${shouldReRender}`);
          return result;
      })
    : LogEntriesComponent;

export function IsFirstEntryOfDay(data: ILogEntry[], row: ILogEntry) {
    const currentRow = data.find((elem) => elem.id === row.id)!;
    const currentDate = moment(currentRow.lastmodifiedtime)
        .local()
        .format("YYYY-MM-DD");
    const currentRowIndex = data.indexOf(currentRow);

    const isLastRow = currentRowIndex === data.length - 1;
    if (isLastRow) {
        return false;
    }

    const previousDate = moment(data[currentRowIndex + 1].lastmodifiedtime)
        .local()
        .format("YYYY-MM-DD");

    if (moment(currentDate).format("D") !== moment(previousDate).format("D")) {
        return true;
    }

    return false;
}
